/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'app/shared/ui';
import { noop } from 'app/shared/utils/utils';
import { IconCloseSt } from 'app/marketplace/SlideInBanners/CrmBanner/MobileBanner/MobileBanner.css';
import { useSlideIn } from 'app/marketplace/SlideInBanners/shared/hooks/mobile/useSlideIn';
import { MobileForm } from 'app/marketplace/SlideInBanners/shared/Components/MobileForm/MobileForm';
import { NEWSLETTER_SOURCE } from 'app/marketplace/crm/constants';
import {
  formTranslations,
  successTranslations,
} from 'app/marketplace/SlideInBanners/UserSurveyBanner/MobileBanner/translationMessages';
import { tracking } from 'app/marketplace/SlideInBanners/UserSurveyBanner/MobileBanner/MobileBanner.tracking';

import {
  BannerActionsSt,
  BannerButtonsWrapperSt,
  BannerHeadingSt,
  BannerTextSt,
  CancelButtonTextSt,
  ImageSt,
  ModalSt,
} from './MobileBanner.css';

export const MobileBanner = ({
  target,
  threshold,
  onClose,
  areCookiesAccepted,
  openOverlay,
  closeOverlay,
  onFormSubmit,
  finishSubmit,
  submitted,
}) => {
  const [mode, changedToVisible, setMode] = useSlideIn(threshold, target);

  useEffect(() => {
    if (changedToVisible) {
      tracking.changedToVisible();
    }
  }, [changedToVisible]);

  const closeModal = () => {
    tracking.dismissed();
    setMode('slideOut');
    setTimeout(() => {
      onClose(areCookiesAccepted);
    }, 500);
  };

  const handleClick = (e) => {
    e.preventDefault();
    tracking.openModal();
    openOverlay(MobileForm, {
      props: {
        onFormSubmit,
        finishSubmit,
        openOverlay,
        closeOverlay,
        source: NEWSLETTER_SOURCE.mobileUserSurvey,
        tracking,
        formTranslations,
        successTranslations,
      },
    });
  };

  if (submitted) return null;

  return (
    <ModalSt mode={mode}>
      <ImageSt>
        <img
          src="/assets/user-survey/UX_Survey_Mobile.png"
          alt="mobile crm banner"
        />
      </ImageSt>
      <BannerHeadingSt>Wilkommen auf heycar!</BannerHeadingSt>
      <BannerTextSt>
        Bist du mit unserer Webseite zufrieden? Bewerte deine Erfahrung auf
        heycar und gewinne einen 200€ Shell-Tankgutschein.
      </BannerTextSt>
      <BannerActionsSt>
        <BannerButtonsWrapperSt>
          <Button unstyled onClick={closeModal}>
            <CancelButtonTextSt>Jetzt nicht</CancelButtonTextSt>
          </Button>
        </BannerButtonsWrapperSt>
        <BannerButtonsWrapperSt onClick={handleClick}>
          <Button variant={target === 'CLP' ? 'primary' : 'secondary'}>
            Teilnehmen
          </Button>
        </BannerButtonsWrapperSt>
      </BannerActionsSt>
      <IconCloseSt onClick={closeModal} className="if-icon-close" />
    </ModalSt>
  );
};

MobileBanner.propTypes = {
  onFormSubmit: PropTypes.func,
  finishSubmit: PropTypes.func,
  threshold: PropTypes.number.isRequired,
  areCookiesAccepted: PropTypes.bool,
  onClose: PropTypes.func,
  submitted: PropTypes.bool,
  target: PropTypes.string.isRequired,
  openOverlay: PropTypes.func,
  closeOverlay: PropTypes.func,
};

MobileBanner.defaultProps = {
  onFormSubmit: noop,
  finishSubmit: noop,
  areCookiesAccepted: false,
  onClose: noop,
  openOverlay: noop,
  closeOverlay: noop,
  submitted: false,
};
